import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import { useAuth } from "../context/AuthContext";
import { formatApiError } from "../lib/api";

export default function Auth() {
  const [mode, setMode] = useState("login");
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const { login, register } = useAuth();
  const navigate = useNavigate();

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      const user = mode === "login" ? await login(email, password) : await register(name, email, password);
      navigate(user.role === "admin" ? "/admin" : "/account");
    } catch (err) {
      setError(formatApiError(err));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-[85vh] flex items-center justify-center px-4 pt-16" data-testid="auth-page">
      <motion.div
        initial={{ opacity: 0, y: 30 }} animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.7, ease: [0.16, 1, 0.3, 1] }}
        className="w-full max-w-md border border-white/10 bg-card p-8 md:p-10"
      >
        <p className="eyebrow mb-3">{mode === "login" ? "Welcome back" : "Join the crew"}</p>
        <h1 className="font-display text-3xl uppercase tracking-tight">{mode === "login" ? "Login" : "Create account"}</h1>

        <div className="grid grid-cols-2 gap-2 mt-8 mb-6">
          <button data-testid="auth-mode-login" onClick={() => setMode("login")} className={`py-2.5 border font-mono text-xs uppercase tracking-widest transition-colors ${mode === "login" ? "bg-kinetic border-kinetic text-white" : "border-white/15 text-zinc-400"}`}>Login</button>
          <button data-testid="auth-mode-register" onClick={() => setMode("register")} className={`py-2.5 border font-mono text-xs uppercase tracking-widest transition-colors ${mode === "register" ? "bg-kinetic border-kinetic text-white" : "border-white/15 text-zinc-400"}`}>Register</button>
        </div>

        <form onSubmit={submit} className="space-y-4">
          {mode === "register" && (
            <input data-testid="auth-name-input" required value={name} onChange={(e) => setName(e.target.value)} placeholder="FULL NAME" className="input-dark font-mono uppercase text-xs tracking-widest" />
          )}
          <input data-testid="auth-email-input" required type="email" value={email} onChange={(e) => setEmail(e.target.value)} placeholder="EMAIL" className="input-dark font-mono uppercase text-xs tracking-widest" />
          <input data-testid="auth-password-input" required type="password" value={password} onChange={(e) => setPassword(e.target.value)} placeholder="PASSWORD" className="input-dark font-mono uppercase text-xs tracking-widest" />
          {error && <p className="font-mono text-xs text-red-500 uppercase tracking-widest" data-testid="auth-error">{error}</p>}
          <button data-testid="auth-submit-button" disabled={loading} className="btn-kinetic w-full disabled:opacity-50">
            {loading ? "Hold on…" : mode === "login" ? "Login" : "Create account"}
          </button>
        </form>
        <p className="font-mono text-[10px] uppercase tracking-widest text-zinc-600 mt-6 text-center">
          Accounts unlock order history & live tracking
        </p>
      </motion.div>
    </div>
  );
}
